import React from 'react';

const Emoji = ({ children, label, ...rest }) => {
  return <span role="img" aria-label={label} {...rest}>{children}</span>;
};

export default React.memo(Emoji);
